import { FC } from 'react'
import { Page } from '../../../components/Page'
import { AddressConfirmation } from './AddressConfirmation'

const AddressConfirmationPage: FC = () => {
  return (
    <Page title={'Address Change Scheduler'}>
      <AddressConfirmation title={'Scheduled Address Changes'} />
    </Page>
  )
}

export { AddressConfirmationPage }
